<template>
  <div class="w-full h-screen py-12 flex flex-col gap-y-4 overflow-y-auto">
    <RouterLink
      to="/"
      :class="{ 'text-primary bg-primary/30': matchedRoute.includes('/') }"
      class="flex gap-x-4 items-center hover:text-primary hover:bg-primary/30 py-3 px-4"
      @click="onRouteClick"
    >
      <faChevronRight class="w-3 fill-primary" />
      {{ $t('home') }}
    </RouterLink>
    <div :key="key" v-for="(item, key) in navMenu">
      <SubmenuBuilder v-if="'children' in item" :menu-item="item" />

      <RouterLink
        v-else
        :key="key"
        :to="item.path"
        :class="{ 'text-primary bg-primary/30': matchedRoute.includes(item.path) }"
        class="flex gap-x-4 items-center hover:text-primary hover:bg-primary/30 py-3 px-4"
        data-parent="mobile-menu"
        @click="onRouteClick"
      >
        <faChevronRight class="w-3 fill-primary" />
        {{ $t(item.label) }}
      </RouterLink>
    </div>
  </div>
</template>

<script setup>
import faChevronRight from '@/assets/icons/faChevronRight.svg?component'
import SubmenuBuilder from '@/components/headers/mobile_menu/SubmenuBuilder.vue'
import useMenuBuilder from '@/composables/useMenuBuilder.js'
import { useGlobalStore } from '@/stores/global'
import { computed, onMounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const route = useRoute()
const isLoading = ref(true)
const navMenu = ref([])
const profileMenu = ref([])
const authStore = useAuthStore()

const globalStore = useGlobalStore()

const matchedRoute = computed(() => {
  return route.matched.map((m) => m.path)
})

const fetchMenu = async () => {
  console.info('fetching menu...')
  isLoading.value = true
  const { nav, profile } = await useMenuBuilder()

  navMenu.value = nav
  profileMenu.value = profile
  isLoading.value = false
}

onMounted(async () => {
  await fetchMenu()
})

const onRouteClick = () => {
  globalStore.$patch((state) => (state.startbarState = false))
}
</script>

<script>
export default { name: 'MobileMenu' }
</script>

<style lang="scss" scoped></style>
